<template>
  <div id="terms">
    <div class="row" style="margin-top: 150px;">
      <div class="col-md-2"></div>
      <div class="col-md-8">
        <h3>Service Terms and Conditions</h3>
        <h3>1. Definitions:</h3>
        <div>
          <ul style="list-style: none;">
            <li>
              <strong>a.</strong>
              <span
                >Platform – As provided: www.fertimo.com accessible by
                Super-User account registered to the User.</span
              >
            </li>
            <li>
              <strong>b.</strong>
              <span
                >Platform Modules – Functionality and pages of the Platform
                including information and reports.</span
              >
            </li>
            <li>
              <strong>c.</strong>
              <span
                >Service – Functionality of the platform as indicated by this
                agreement.</span
              >
            </li>
            <li>
              <strong>d.</strong>
              <span
                >Provider – First Counterpart to this agreement, which is solely
                entitled and responsible for delivery and rendering of the
                services within the scope of this agreement;</span
              >
            </li>
            <li>
              <strong>e.</strong>
              <span
                >User – Second Counterpart to this agreement, which has rights
                and liabilities undertaken pursuant this agreement;</span
              >
            </li>
            <li>
              <strong>f.</strong>
              <span
                >Client – Potential third non-contractual party to this
                agreement, who is receiving final service benefits from
                Provider’s and User’s cumulative engagements within this
                agreement;</span
              >
            </li>
            <li>
              <strong>g.</strong>
              <span
                >Wallet – Personal balance account of a user company, where he
                is able to pay for platform fees by means of provided payment
                methods, from where provider will subtract amounts as indicated
                in article 4.a</span
              >
            </li>
            <li>
              <strong>h.</strong>
              <span
                >Wire transfer – A payment to provider bank/money account by
                means of offered payment methods</span
              >
            </li>
            <li>
              <strong>i.</strong>
              <span
                >Helpdesk – Support system, accessible over www.fertimo.com user
                panel.</span
              >
            </li>
            <li>
              <strong>j.</strong>
              <span
                >Party – Individually referred each counterpart of this
                agreement;</span
              >
            </li>
            <li>
              <strong>k.</strong>
              <span
                >Parties – Collectively referred counterparts of this
                agreement.</span
              >
            </li>
            <li>
              <strong>l.</strong>
              <span
                >Super-User account – Granted by provider to the User that
                entitles him/her all the rights to use the Platform according to
                the chosen service plan.</span
              >
            </li>
            <li>
              <strong>m.</strong>
              <span
                >System-User – An employee of the User, that User has registered
                to his/her company account on the Platform and given him the
                access rights to different modules of the Platform.</span
              >
            </li>
          </ul>
        </div>
        <h3>2. General Conditions</h3>
        <div>
          <ul style="list-style: none;">
            <li>
              <strong>a.</strong>
              <span
                >For the purposes of this agreement, the User asdasdasd by
                pushing the provided activation link, agrees that he/she has a
                sufficient authority under domestic and international laws to
                sign this agreement and act on behalf of the company as
                indicated in this agreement by using Super-User account granted
                to him/her by Provider.</span
              >
            </li>
            <li>
              <strong>b.</strong>
              <span
                >User is represented by and therefore liable to any terms and
                conditions (as indicated in this agreement) by a System-User
                accounts granted by him/her and his/her employees (System Users)
                to his/her employees and related parties.</span
              >
            </li>
            <li>
              <strong>c.</strong>
              <span
                >Provider is not liable for User’s activities/responsibilities
                towards the Client;</span
              >
            </li>
            <li>
              <strong>d.</strong>
              <span
                >User is liable for any client personal information obtained by
                it, stored and used within the platform under international and
                domestic law;</span
              >
            </li>
            <li>
              <strong>e.</strong>
              <span
                >User guarantees that any information of client, obtained during
                the ordinary business activities is accepted by client including
                process of such information by Provider;</span
              >
            </li>
            <li>
              <strong>f.</strong>
              <span
                >Provider is entitled to process information stored by user for
                data analysis purposes unless it contradicts client’s best
                interest and existing regulations;</span
              >
            </li>
            <li>
              <strong>g.</strong>
              <span
                >User is obliged to provide true and correct information about
                itself and its business activities, including and not limited to
                its business information.</span
              >
            </li>
          </ul>
        </div>
        <h3>3. Subject of agreement</h3>
        <div>
          <ul style="list-style: none;">
            <li>
              <strong>a.</strong>
              <span
                >User agrees to use the platform provided by Provider for
                business process management under the condition declared in this
                agreement and pay service fees pursuant to this agreement, on
                the other hand, Provider agrees to deliver the Platform service
                within the terms of this agreement.</span
              >
            </li>
          </ul>
        </div>
        <h3>4. Fees and service delivery terms</h3>
        <div>
          <ul style="list-style: none;">
            <li>
              <strong>a.</strong>
              <span
                >Prices for the platform service per club/month are indicated in
                GEL (Or USD for international customers) as follows and may
                change under prior notice by Provider, if such occasion as
                indicated in the article 4.5 arises or by clients request for
                purpose of choosing a different plan:</span
              >
              <ul style="list-style: none;">
                <li>
                  <strong>i.</strong>
                  <span
                    >Free – basic functionality limited to a single system user,
                    including modules:</span
                  >
                  <ol>
                    <li>Club Operations</li>
                    <li>Basic Finance</li>
                    <li>Basic CRM</li>
                    <li>Warehouse</li>
                    <li>No support</li>
                  </ol>
                </li>
                <li>
                  <strong>ii.</strong>
                  <span>350 GEL (149 USD) Enterprise:</span>
                  <ol>
                    <li>Club Operations</li>
                    <li>Finance</li>
                    <li>HRM</li>
                    <li>CRM</li>
                    <li>Warehouse</li>
                    <li>Finance</li>
                    <li>Basic support over helpdesk</li>
                  </ol>
                </li>
                <li>
                  <strong>iii.</strong>
                  <span
                    >750 GEL (319 USD) Network Enterprise (more than one
                    club):</span
                  >
                  <ol>
                    <li>Club Operations</li>
                    <li>Finance</li>
                    <li>HRM</li>
                    <li>CRM</li>
                    <li>Warehouse</li>
                    <li>Finance</li>
                    <li>Basic support over helpdesk</li>
                  </ol>
                </li>
              </ul>
            </li>
            <li>
              <strong>b.</strong>
              <span
                >Provider is obliged to deliver the service according to the 4.a
                article no later than 24 hours after user has agreed and paid
                for the service in full.</span
              >
            </li>
            <li>
              <strong>c.</strong>
              <span
                >Service plan fees indicated in the article 4.a are for a
                calendar month, excluding any domestic taxes in user’s country
                of residence and business operations and payment charges by bank
                or transaction processing company. Total platform service will
                be accumulated on user virtual balance as defined in article
                8.a</span
              >
            </li>
            <li>
              <strong>d.</strong>
              <span
                >Change platform, service and module fees, by notifying user at
                least one month earlier before such changes are
                implemented.</span
              >
            </li>
          </ul>
        </div>
        <h3>5. Payment terms</h3>
        <div>
          <ul style="list-style: none;">
            <li>
              <strong>a.</strong>
              <span
                >All the service fee payments must be credited on to the user
                wallet in advance.</span
              >
            </li>
            <li>
              <strong>b.</strong>
              <span
                >www.fertimo.com monthly subscription service fees should be
                paid in full no later than 10 days for the previous month. The
                balance due is shown on the corresponding company account on the
                billing page.</span
              >
            </li>
            <li>
              <strong>c.</strong>
              <span
                >Any service fees related to the payment will be subtracted by
                Provider and credited net to the User Wallet</span
              >
            </li>
            <li>
              <strong>d.</strong>
              <span
                >Refund can be requested only for the outstanding balance net of
                any accrued expenses. Refund will be commenced within 1 calendar
                month. Such a request should be made from the email (registered
                as a superuser for the specific company) and will executed by
                crediting bank card used to pay the bills on
                www.fertimo.com.</span
              >
            </li>
          </ul>
        </div>
        <h3>6. Rights and Duties</h3>
        <div>
          <ul style="list-style: none;">
            <li>
              <strong>a.</strong> <span>The Provider is obliged to:</span>
              <div>
                <ul style="list-style: none;">
                  <li>
                    <strong>i.</strong>
                    <span
                      >Deliver the service as per terms and conditions of this
                      Agreement, without any potential material and legal
                      defects.</span
                    >
                  </li>
                  <li>
                    <strong>ii.</strong>
                    <span
                      >In the event of failure of the delivery within the
                      specified terms (including poor quality, incomplete
                      delivery) reimburse fees paid by User pro rata days.</span
                    >
                  </li>
                  <li>
                    <strong>iii.</strong>
                    <span
                      >Ensure at least 99% uptime of the Platform for 24/7 on
                      the internet</span
                    >
                  </li>
                  <li>
                    <strong>iv.</strong>
                    <span
                      >Provide necessary measures to secure Client and User
                      information on the Platform</span
                    >
                  </li>
                  <li>
                    <strong>v.</strong>
                    <span
                      >Provide support services as indicated in 4.a clause</span
                    >
                  </li>
                  <li>
                    <strong>vi.</strong>
                    <span
                      >Notify User for any Platform updates, shortfalls and
                      maintenance events and provide necessary information for
                      User recommended actions</span
                    >
                  </li>
                  <li>
                    <strong>vii.</strong>
                    <span
                      >Review User’s comments and questions and resolve problems
                      quickly</span
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <strong>b.</strong> <span>The User is obliged to:</span>
              <div>
                <ul style="list-style: none;">
                  <li>
                    <strong>i.</strong>
                    <span
                      >Pay the total value of the service fees to the Supplier
                      within the terms specified by this Agreement;</span
                    >
                  </li>
                  <li>
                    <strong>ii.</strong>
                    <span
                      >Report any errors or inconsistencies in case of such
                      findings without delay;</span
                    >
                  </li>
                  <li>
                    <strong>iii.</strong>
                    <span
                      >Follow the guidelines and instructions as prescribed by
                      Provider for the purposes of receiving the high-quality
                      service;</span
                    >
                  </li>
                  <li>
                    <strong>iv.</strong>
                    <span
                      >Ensure security of access to his/her Super-User and other
                      System user accounts by taking necessary steps to store
                      account access credentials on sufficiently secured OS
                      platforms.</span
                    >
                  </li>
                  <li>
                    <strong>v.</strong>
                    <span
                      >Not to transfer or give access to his Super-User and
                      system-user accounts to any other third party not related
                      to this agreement in any way. This does not account for
                      employees of the User.</span
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <strong>c.</strong> <span>Provider is entitled to:</span>
              <div>
                <ul style="list-style: none;">
                  <li>
                    <strong>i.</strong>
                    <span
                      >demand reimbursement of the value of the Agreement at the
                      agreed time.</span
                    >
                  </li>
                  <li>
                    <strong>ii.</strong>
                    <span
                      >Withhold service in case User fails to fulfill any of its
                      obligations and restrict its employees’ access to the
                      Platform by the period of maximum 3 month after Provider
                      is aware of such a breach</span
                    >
                  </li>
                  <li>
                    <strong>iii.</strong>
                    <span
                      >Delate information stored by the User on the Platform
                      after the User fails to make remedies for the breaches
                      within the period mentioned in article 6.c.ii</span
                    >
                  </li>
                  <li>
                    <strong>iv.</strong>
                    <span
                      >Update platform design and functionality in his own best
                      interests, in case it is not undermining best interests of
                      the User.</span
                    >
                  </li>
                  <li>
                    <strong>v.</strong>
                    <span
                      >Provide Users Clients with client portal services access
                      including a web-page www.fertimo.com mobile apps and any
                      other means of digital access to it.</span
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <strong>d.</strong>
              <span
                >User is entitled to request reimbursement for the services that
                was paid in full but Provider failed to deliver within the
                agreed time or quality</span
              >
            </li>
            <li>
              <strong>e.</strong>
              <span
                >The Parties undertake to fulfill their obligations under this
                Agreement in good faith.</span
              >
            </li>
            <li>
              <strong>f.</strong>
              <span
                >The termination of certain provisions of the Agreement does not
                relieve the parties from fulfilling other obligations.</span
              >
            </li>
          </ul>
        </div>
        <h3>7. Force Majeure</h3>
        <div>
          <ul style="list-style: none;">
            <li>
              <strong>a.</strong>
              <span
                >In case any circumstances arise after signing this Agreement
                which prevents, fully or partially, fulfillment of the
                obligations under the present agreement by any of the parties,
                namely: flood, fire, war, embargo, blockade, natural disasters,
                export and import prohibition or other circumstances beyond the
                control of the parties, the time of fulfillment of the
                obligations shall be extended by corresponding period. The
                parties shall appraise each other of any such circumstances
                within 20 (twenty) calendar days from the commencement
                thereof.</span
              >
            </li>
            <li>
              <strong>b.</strong>
              <span
                >Both parties shall do their best to avoid or remove such
                circumstances and continue the fulfillment of their obligations
                as soon as such circumstances are removed. If such circumstances
                last more than 6 (six) months, either Party has the right to
                terminate the present agreement and, in this case, neither party
                has the right to claim a compensation of their losses from other
                party and any funds paid in advance shall be returned to the
                Buyer</span
              >
            </li>
          </ul>
        </div>
        <h3>8. Confidentiality</h3>
        <div>
          <ul style="list-style: none;">
            <li>
              <strong>a.</strong>
              <span
                >“Confidential Information” shall mean any and all information
                disclosed by one Party hereto (“Disclosing Party”) to the other
                Party (“Receiving Party”) pursuant to this Agreement which is
                described as (or provided under circumstances indicating it is)
                confidential or proprietary. Regardless of whether specifically
                identified as confidential or proprietary.</span
              >
            </li>
            <li>
              <strong>b.</strong>
              <span
                >Except to the extent expressly authorized by this Agreement or
                otherwise agreed in writing by the Parties, each Party agrees
                that it shall keep confidential and shall not publish or
                otherwise disclose and shall not use for any purpose other than
                as provided for in this Agreement any Confidential Information
                disclosed to it by the other Party pursuant to this
                Agreement.</span
              >
            </li>
            <li>
              <strong>c.</strong>
              <span
                >“Confidential Information” shall include any information
                provided by the Disclosing Party concerning the business,
                technology and information of Disclosing Party and any third
                party with which Disclosing Party deals, including, without
                limitation, business plans, technical data, solutions, product
                ideas, contracts, financial information, inventions, sales
                leads, strategic alliances, partners and client lists.</span
              >
            </li>
            <li>
              <strong>d.</strong>
              <span
                >“Confidential Information” shall not include any information
                that: (i) becomes publicly known through no wrongful act of
                Receiving Party or (ii) is required by law, regulation or order
                of any court or other government or regulatory agency to be
                disclosed, provided that Receiving Party shall notify Disclosing
                Party of such requirement so that Disclosing Party may seek an
                appropriate protective order.</span
              >
            </li>
            <li>
              <strong>e.</strong>
              <span
                >Parties shall comply with confidentiality requirement pursuant
                to this agreement within 5 years from the day this agreement is
                considered terminated.</span
              >
            </li>
            <li>
              <strong>f.</strong>
              <span
                >All Confidential Information shall remain the property of the
                Party disclosing the same (the ‘Disclosing Party’). Without the
                prior written consent of ‘Disclosing Party’, the Party receiving
                the same (being the ‘Receiving Party’) shall not disclose, nor
                shall it permit any others to disclose, to any third party or
                otherwise use, or permit any others to use, any Confidential
                Information other than for the Purpose. The Parties agree that
                any Confidential Information disclosed prior to the Effective
                Date shall be protected by the terms of this Agreement. The
                Receiving Party shall use no less than best efforts for care in
                protecting the Confidential Information.</span
              >
            </li>
            <li>
              <strong>g.</strong>
              <span
                >User is liable for any information loss or disclosure which may
                cause damage to the User, Provider or Client, which may also be
                a result of activities on Platform by User and its
                employees.</span
              >
            </li>
          </ul>
        </div>
        <h3>9. Indemnification</h3>
        <div>
          <ul style="list-style: none;">
            <li>
              <strong>a.</strong>
              <span
                >The Provider shall be solely responsible for the design,
                development, supply, production and performance of its products
                (in case of existence) and the protection of its trade names and
                patents. User agrees to indemnify, hold the Provider harmless
                against and pay all losses, costs, damages or expenses,
                whatsoever, including counsel fees, which the Provider may
                sustain or incur on account of infringement or alleged
                infringements of patents, trademarks or trade names resulting
                from the sale of the Provider’s products, or arising on account
                of warranty claims, negligence claims, product liability claims
                or similar claims by third parties.</span
              >
            </li>
          </ul>
        </div>
        <h3>10. Governing Law and Dispute Resolution.</h3>
        <div>
          <ul style="list-style: none;">
            <li>
              <strong>a.</strong>
              <span
                >This Agreement and any non-contractual obligations connected
                with it shall be governed by and construed in accordance with
                Georgian Law. Any dispute arising out of or in connection with
                this Agreement, including any question regarding its existence,
                validity or termination, which cannot be resolved through
                discussions between the Parties on an amicable basis within
                thirty (30) days from the date of the dispute, the dispute shall
                be referred to and finally resolved by Tbilisi City Court.</span
              >
            </li>
          </ul>
        </div>
        <h3>11. Severability</h3>
        <div>
          <ul style="list-style: none;">
            <li>
              <strong>a.</strong>
              <span
                >If any provision(s) of this Agreement shall be held invalid,
                illegal, against public policy or otherwise unenforceable for
                any reason by a court of competent jurisdiction, against public
                policy or otherwise unenforceable, the validity of the remaining
                portions or provisions hereof shall not be affected. The
                remainder of the Agreement shall be valid and enforceable and
                the parties shall negotiate in good faith a substitute, valid
                and enforceable provision which most nearly effects the Parties’
                intent in entering into this Agreement.</span
              >
            </li>
          </ul>
        </div>
        <h3>12. Waiver</h3>
        <div>
          <ul style="list-style: none;">
            <li>
              <strong>a.</strong>
              <span
                >The Failure of either party at any time to enforce any rights
                or remedy available to it under this Agreement or otherwise with
                respect to any breach or failure by the other Party shall not be
                construed to be a waiver of such right or remedy with respect to
                any other breach or failure of the other Party.</span
              >
            </li>
          </ul>
        </div>
        <h3>13. Termination</h3>
        <div>
          <ul style="list-style: none;">
            <li>
              <strong>a.</strong>
              <span
                >Should either party require this agreement to end, we agree to
                give written notice by e-mail or written letter
                communication.</span
              >
            </li>
            <li>
              <strong>b.</strong>
              <span
                >The agreement shall be considered terminated at the day of
                receiving the intent of termination by means of sub article “a”
                of article 10.</span
              >
            </li>
            <li>
              <strong>c.</strong>
              <span
                >If User does not use the Platform for consecutive one-year
                period Provider is entitled to terminate the agreement and
                suspend User account</span
              >
            </li>
            <li>
              <strong>d.</strong>
              <span
                >In case the agreement is terminated Provider has no obligation
                to keep any data related to the User and its Clients</span
              >
            </li>
          </ul>
        </div>
        <h3>14. European General Data Protection Regulation (GDPR)</h3>
        <div>
          <ul style="list-style: none;">
            <li>
              <strong>a.</strong>
              <span
                >The User has been informed by the Provider, that for them
                compliance with all applicable data protection laws is of the
                utmost importance; this also and particularly applies to the
                European General Data Protection Regulation of April 27, 2016
                (Regulation (EU) 2016/679) (the GDPR). Against this background,
                the User undertakes to use best efforts that during the
                activities, milestones and measures in light of this agreement
                will continue to be pursued and accomplished by User and its
                data processing will be organized and operated in a manner,
                which is compliant with the requirements of the GDPR.</span
              >
            </li>
          </ul>
        </div>
        <h3>15. Miscellaneous</h3>
        <div>
          <ul style="list-style: none;">
            <li>
              <strong>a.</strong>
              <span
                >Neither the party shall transfer to a third party their right
                and obligations under this agreement without the written consent
                of the other party such consent not to be unreasonably
                withheld.</span
              >
            </li>
            <li>
              <strong>b.</strong>
              <span
                >Provider is entitled to make any amendments to this Agreement,
                which shall be subject of notification to User by written letter
                or E-mail communication means, if User does not agree with the
                changes made in the agreement, parties shall within 15-day
                period amicably resolve the issue. If the issue will not be
                resolved within the mentioned time-period, either party may
                terminate this agreement as mentioned in Sub article “a” of
                article 13 of the agreement.</span
              >
            </li>
            <li>
              <strong>c.</strong>
              <span
                >The agreement comes into full force after, User agrees the
                provided terms by indicating “Agreed terms and conditions” on
                the Platform</span
              >
            </li>
            <li>
              <strong>d.</strong>
              <span
                >This Agreement and the exhibits (including any reference and
                the part of the web: www.fertimo.com) hereto represent and
                constitute the entire agreement between the parties, and
                supersedes and merges all prior negotiations, agreements and
                understandings, oral or written, with respect to any and all
                matters between the Provider and User.</span
              >
            </li>
            <li>
              <strong>e.</strong>
              <span
                >The agreement is presented in English and one additional
                preferred language as chosen by the User, in case of
                inconsistency between the two versions, the English version will
                prevail.</span
              >
            </li>
            <li>
              <strong>f.</strong>
              <span
                >The parties agree that accepting the terms and conditions of
                the agreement by User through electronical (reference to the
                www.fertimo.com) means, shall be considered as a duly signature
                and delivery of manually executed counterpart of this Agreement
                to each parties.</span
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="col-md-2"></div>
    </div>

    <footer
      class="footer_area h_footer_dark pos_footer_area security_footer_area geo_font"
      style="margin-top: 50px;"
    >
      <img class="leaf_left" src="img/pos/leaf-left.png" alt="" />
      <img class="leaf_right" src="img/pos/leaf-right.png" alt="" />
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="f_widget dark_widget company_widget">
              <a href="index.html" class="f-logo"
                ><img src="img/logo2.png" alt=""
              /></a>
              <p>{{ Lang("© 2020 Wellness Corporation, LLC") }}</p>
              <div class="f_social_icon">
                <a
                  href="https://www.facebook.com/Fertimo-111456580554500/"
                  target="_blank"
                  class="ti-facebook"
                ></a>
                <!-- <a href="#" class="ti-youtube"></a> -->
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="f_widget dark_widget about-widget pl_20 geo_font">
              <h3 class="f-title f_500 t_color f_size_18 mb_40">
                {{ Lang("Useful Links") }}
              </h3>
              <ul class="list-unstyled f_list geo_font">
                <li>
                  <a class="geo_font" href="#">{{ Lang("Company") }}</a>
                </li>
                <li>
                  <a class="geo_font" href="#">{{ Lang("Blog") }}</a>
                </li>
                <li>
                  <a class="geo_font" href="#">{{ Lang("Partners") }}</a>
                </li>
                <li>
                  <a class="geo_font" href="#">{{ Lang("Careers") }}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 geo_font">
            <div class="f_widget dark_widget about-widget pl_20 geo_font">
              <h3 class="f-title f_500 t_color f_size_18 mb_40 ">
                {{ Lang("Help") }}
              </h3>
              <ul class="list-unstyled f_list geo_font">
                <li>
                  <a class="geo_font" href="#">{{ Lang("FAQ") }}</a>
                </li>
                <li>
                  <router-link class="geo_font" v-bind:to="'terms'">{{
                    Lang("Term & conditions")
                  }}</router-link>
                </li>
                <li>
                  <a class="geo_font" href="#">{{ Lang("Reporting") }}</a>
                </li>
                <li>
                  <a class="geo_font" href="#">{{ Lang("Pricing") }}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-2 col-md-6">
            <div class="f_widget dark_widget about-widget pl_20">
              <h3 class="f-title f_500 t_color f_size_18 mb_40">
                {{ Lang("Contact") }}
              </h3>
              <ul class="list-unstyled f_list">
                <li v-on:click="window.scrollTo(0, 0)">
                  <router-link class="geo_font" v-bind:to="'contact'">{{
                    Lang("Contact")
                  }}</router-link>
                </li>

                <li>
                  <a class="geo_font" href="#">{{ Lang("Support") }}</a>
                </li>
                <li>
                  <a class="geo_font" href="#">{{ Lang("Sales") }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          class="pos_footer_bottom justify-content-between d-flex align-items-end"
        >
          <img class="pos_women" src="img/pos/women.png" alt="" />
          <img src="img/pos/people.png" alt="" />
          <img class="pos_women" src="img/pos/man.png" alt="" />
        </div>
      </div>
      <svg class="wave_shap" xmlns="https://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          opacity="0.302"
          fill="rgb(73, 69, 140)"
          d="M22.990,11.999 C22.990,11.999 -62.334,196.188 102.000,90.998 C236.033,5.204 349.217,18.152 512.000,80.998 C773.380,181.909 898.075,49.752 1051.000,15.998 C1316.369,-42.574 1488.518,78.268 1581.000,112.999 C1783.485,189.036 1942.990,61.999 1942.990,61.999 L1942.990,211.999 L22.990,211.999 L22.990,11.999 Z"
        />
      </svg>
    </footer>
  </div>
</template>
<script>
import Vue from "vue";
import Langs from "@/mixins/Lang.js";
export default Vue.extend({
  name: "HomePage",
  mixins: [Langs],
  data: function() {
    return {};
  },
  mounted: function() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  methods: {}
});
</script>



// WEBPACK FOOTER //
// src/components/TermsConditions/Terms.vue